import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 sm:px-6 bg-graphite text-center text-ivory/60 text-xs sm:text-sm" data-id="element-74">
      <p className="leading-relaxed max-w-3xl mx-auto font-medium mb-5" data-id="element-75">
        © {new Date().getFullYear()} FITNESS SENIOR PRO™ — Tutti i Diritti
        Riservati.
        <br data-id="element-76" />
        Il contenuto di questa pagina è solo a scopo educativo e non sostituisce
        il consiglio medico professionale. Seguire sempre le linee guida di
        sicurezza appropriate quando si lavora con adulti maggiori.
      </p>
      <div className="flex justify-center gap-4 sm:gap-6 font-bold tracking-widest uppercase text-[10px] sm:text-xs" data-id="element-77">
        <a href="#" className="hover:text-gold transition-colors" data-id="element-78">
          Termini e Condizioni
        </a>
        <span data-id="element-79">·</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-80">
          Politica sulla Privacy
        </a>
        <span data-id="element-81">·</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-82">
          Contatti
        </a>
      </div>
    </footer>;
}